import React, {useState, useEffect} from "react";
import { TextField, Checkbox, FormControlLabel, Grid, Typography, Box, Container, Button, FormLabel, RadioGroup, Radio, FormGroup, FormControl, FormHelperText } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from "./api.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { useValidatedChangeWithError } from "./common/useValidatedChangeWithError.js";
import { intValidator, decimalValidator } from "./common/validators.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp3Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [sameAsInvoice, setSameAsInvoice] = useState("different");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_3_name: "",
    user_3_department: "",
    user_3_phone: "",
    user_3_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    in_moving: "",
    out_moving: "",
    moving_select: null,
    moving_name: "",
    place: "",
    address: "",
    user_name: "",
    phone_number: "",
    goods_name: "",
    goods_number: 0,
    style: "",
    weight: 0,
    max_weight: 0,
    quantity: 0,
    max_length: 0,
    max_width: 0,
    max_height: 0,
    max_quantity: 0,
    in_date: "",
    out_date: "",
    iron_plate: null,
    norm_num: 0,
    big_num: 0,
    trail_num: 0,
    moving_device: "",
    alfa_text: "",
    select_plans: [],
    zip: "",
  });

  const [errors, setErrors] = useState({
    goods_number: "",
    weight: "",
    max_weight: "",
    quantity: "",
    max_length: "",
    max_width: "",
    max_height: "",
    norm_num: "",
    big_num: "",
    trail_num: "",
  });

  const handleValidatedChange = useValidatedChangeWithError(
    setFormData,
    setErrors
  );
  
  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");
  const handleChange = (field, validator) => (e) => {
    const rawValue =
      e.target.type === "checkbox"
        ? e.target.checked
        : e.target.value;

    if (!validator) {
      setFormData((prev) => ({ ...prev, [field]: rawValue }));
      return;
    }

    const { value, error } = validator(rawValue);

    if (value !== null) {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
  };
  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  const selectedPlans = Array.isArray(formData.select_plans)
    ? formData.select_plans
    : formData.select_plans
      ? formData.select_plans.split(",")
      : [];

  // チェックボックス変更時のハンドラ例
  const handleSelectPlansChange = (option) => (event) => {
    let newPlans = [...selectedPlans];
    if (event.target.checked) {
      if (!newPlans.includes(option)) {
        newPlans.push(option);
      }
    } else {
      newPlans = newPlans.filter((plan) => plan !== option);
    }
    // 変更後はカンマ区切りの文字列で formData にセット
    setFormData({
      ...formData,
      select_plans: newPlans.join(","),
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_3_name: mypageData.user_name || "",
        user_3_department: mypageData.department || "",
        user_3_phone: mypageData.phone_number || "",
        user_3_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_3_name: "",
        user_3_department: "",
        user_3_phone: "",
        user_3_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  console.log(formData)

  const handleSameAsInvoice = (value) => {
    setSameAsInvoice(value);

    if (value === "same") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: mypageData.company_name || "",
        invoice_user_name: mypageData.user_name || "",
        invoice_email: mypageData.email || "",
        invoice_address: mypageData.address || "",
        invoice_zip: mypageData.zip_code || "",
        invoice_tel: mypageData.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } else if (value === "different") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
      }));
      setInvFieldsDisabled(false);
    }
  };

  const handleParentInvoiceClick = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
      const data = res.data;
      console.log(data)
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: data.company_name || "",
        invoice_user_name: data.user_name || "",
        invoice_email: data.email || "",
        invoice_address: data.address || "",
        invoice_zip: data.zip_code || "",
        invoice_tel: data.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } catch (error) {
      console.error("親出展者の請求情報取得に失敗しました:", error);
      alert("親出展者の情報を取得できませんでした。");
    } finally {
      setLoading(false);
    }
  };

  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

  const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

  useEffect(() => {
    const fetchO3InitialData = async () => {
      try {
        const [resStatus, resO3, resMypage] = await Promise.all([
          api.get(`/api/submission-status/${exhibitorId}`),
          api.get(`/api/o3submission/${exhibitorId}`),
          api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o3Status = resStatus.data?.o3_status || "";
        const o3Data = resO3.data || {};
        const mypage = resMypage.data || {};
        if (o3Status === "申請しない") {
          setNotApply(true);
          setFormData({
            user_3_name: null,
            user_3_department: null,
            user_3_phone: null,
            user_3_tel: null,
            invoice_company_name: null,
            invoice_user_name: null,
            invoice_address: null,
            invoice_email: null,
            invoice_zip: null,
            invoice_tel: null,
            invoice_fax: null,
            in_moving: [],
            out_moving: [],
            moving_select: null,
            moving_name: null,
            place: null,
            address: null,
            user_name: null,
            phone_number: null,
            goods_name: null,
            goods_number: null,
            style: null,
            weight: null,
            max_weight: null,
            quantity: null,
            max_length: null,
            max_width: null,
            max_height: null,
            max_quantity: null,
            in_date: null,
            out_date: null,
            iron_plate: null,
            norm_num: null,
            big_num: null,
            trail_num: null,
            moving_device: null,
            alfa_text: null,
            select_plans: [],
            zip: null,
          });
          setFieldsDisabled(false);
        } else {
          if (Object.values(o3Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
          })) {
            setFormData(prev => ({
              ...prev,
              ...o3Data,
              // 搬入時
              in_moving:
                o3Data.in_moving === "どちらも"
                  ? ["会場まで", "トラックから"]
                  : o3Data.in_moving
                  ? o3Data.in_moving.split(",")
                  : [],
              // 搬出時
              out_moving:
                o3Data.out_moving === "どちらも"
                  ? ["トラックへ", "会場から"]
                  : o3Data.out_moving
                  ? o3Data.out_moving.split(",")
                  : [],
              // 他の配列系
              select_plans: Array.isArray(o3Data.select_plans)
                ? o3Data.select_plans
                : o3Data.select_plans
                  ? o3Data.select_plans.split(",")
                  : [],
            }));
            if (
              o3Data.user_3_name === mypage.user_name &&
              o3Data.user_3_department === mypage.department &&
              o3Data.user_3_phone === mypage.phone_number &&
              o3Data.user_3_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            if (
                o3Data.invoice_company_name === mypage.company_name &&
                o3Data.invoice_user_name === mypage.user_name &&
                o3Data.invoice_email === mypage.email &&
                o3Data.invoice_address === mypage.address &&
                o3Data.invoice_tel === mypage.phone_number &&
                o3Data.invoice_zip === mypage.zip_code
            ) {
                setSameAsInvoice("same");
                setInvFieldsDisabled(true);
            } else {
                setInvFieldsDisabled(false);
            }
          }
          setNotApply(false);
        }
      } catch (err) {
        console.error("O3初期データ取得エラー:", err);
      }
    };

    if (exhibitorId) {
      fetchO3InitialData();
    }
  }, [exhibitorId]);

  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
              // 全てnullに初期化（例）
              user_3_name: "",
              user_3_department: "",
              user_3_phone: "",
              user_3_tel: "",
              invoice_company_name: "",
              invoice_user_name: "",
              invoice_email: "",
              invoice_address: "",
              invoice_zip: "",
              invoice_tel: "",
              invoice_fax: "",
              in_moving: null,
              out_moving: null,
              moving_select: null,
              moving_name: null,
              place: null,
              address: null,
              user_name: null,
              phone_number: null,
              goods_name: null,
              goods_number: null,
              style: null,
              weight: null,
              max_weight: null,
              quantity: null,
              max_length: null,
              max_width: null,
              max_height: null,
              max_quantity: null,
              in_date: null,
              out_date: null,
              iron_plate: null,
              norm_num: null,
              big_num: null,
              trail_num: null,
              moving_device: null,
              alfa_text: null,
              select_plans: null,
              zip: null,
          });
      }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

    useEffect(() => {
      if ((isModal || isCorpModal) && propExhibitorId) {
        setExhibitorId(propExhibitorId);
        return;
      }

      const userData = localStorage.getItem("user");

      if (userData) {
        const parsedUser = JSON.parse(userData);
        if (parsedUser?.exhibitor_id) {
          setExhibitorId(parsedUser.exhibitor_id);
        } else {
          console.warn("exhibitor_id が見つかりません");
        }
      } else {
        console.warn("localStorageにuserが存在しません");
      }
    }, [location, isModal, isCorpModal, propExhibitorId]);
  
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const [ submitErrors, setSubmitErrors] = useState({});

    const handleSubmit = async () => {
      try {
        if (!exhibitorId || typeof exhibitorId !== "number") {
          alert("exhibitorId が不正です");
          return;
        }

        // --- ここでDOMから最新値を拾ってformData更新 ---
        const updatedData = { ...formData };

        const fieldsToSync = [
          "user_3_name",
          "user_3_department",
          "user_3_phone",
          "user_3_tel",
          "invoice_company_name",
          "invoice_user_name",
          "invoice_address",
          "invoice_email",
          "invoice_zip",
          "invoice_tel",
          "invoice_fax",
        ];

        fieldsToSync.forEach((field) => {
          const el = document.querySelector(`[name="${field}"]`);
          if (el) {
            updatedData[field] = el.value ?? "";
          }
        });

        setFormData(updatedData);

        const submitErrors = {};

        if (!notApply) {
          if (!updatedData.user_3_name?.trim()) submitErrors.user_3_name = "入力してください";
          if (!updatedData.user_3_phone?.trim()) submitErrors.user_3_phone = "入力してください";
          if (!updatedData.user_3_tel?.trim()) submitErrors.user_3_tel = "入力してください";
          if (!updatedData.invoice_company_name?.trim()) submitErrors.invoice_company_name = "入力してください";
          if (!updatedData.invoice_user_name?.trim()) submitErrors.invoice_user_name = "入力してください";
          if (!updatedData.invoice_email?.trim()) submitErrors.invoice_email = "入力してください";
          if (!updatedData.invoice_address?.trim()) submitErrors.invoice_address = "入力してください";
          if (!updatedData.invoice_zip?.trim()) submitErrors.invoice_zip = "入力してください";
          if (!updatedData.invoice_tel?.trim()) submitErrors.invoice_tel = "入力してください";
          if (!updatedData.select_plans || updatedData.select_plans.length === 0) submitErrors.select_plans = "選択してください";
        }

        const fieldDisplayNames = {
          user_3_name: "担当者名",
          user_3_department: "担当部署",
          user_3_phone: "担当者携帯",
          user_3_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
          select_plans: "依頼内容",
        };

        // エラーあれば早期リターン
        if (Object.keys(submitErrors).length > 0) {
          setSubmitErrors(submitErrors);
          window.scrollTo({ top: 0, behavior: "smooth" });

          const errorMessages = Object.entries(submitErrors)
            .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
            .join("\n");

          alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
          return;
        }

        // 保存用に配列を文字列化
        const formDataForSend = {
          ...updatedData,
          select_plans: Array.isArray(updatedData.select_plans)
            ? updatedData.select_plans.join(",")
            : updatedData.select_plans,
          in_moving: updatedData.in_moving ? String(updatedData.in_moving) : "",
          out_moving: updatedData.out_moving ? String(updatedData.out_moving) : "",
          moving_select: typeof updatedData.moving_select === "boolean" ? updatedData.moving_select : null,
          iron_plate: updatedData.iron_plate ? String(updatedData.iron_plate) : "",
        };

        const payload = {
          exhibitor_id: exhibitorId,
          formData: formDataForSend,
          notApply: notApply,
        };

        const res = await api.post("/api/submit-o3", payload);

        if (res.status === 200) {
          alert("保存成功");
        } else {
          alert("保存失敗");
        }

        setTimeout(() => {
          if (isModal) {
            setFormModalOpen(false);
          } else {
            if (user?.user_id === 0) {
              navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
            } else {
              navigate(`/mypage/${user?.mypage_id}`);
            }
          }
        }, 1000);
      } catch (err) {
        console.error(err);
        alert("エラー");
      }
    };


  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      max_quantity:
        (prev.max_length || 0) *
        (prev.max_width || 0) *
        (prev.max_height || 0)
    }));
  }, [formData.max_length, formData.max_width, formData.max_height]);

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <div>
        {!isCorpModal &&(
          <Header
            title="SDGs 子ども・ユースフェア2026 運送申請"
            companyName={mypageData?.company_name}
          />
        )}
        <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }} className='sm-block'>
        {!isCorpModal &&(
          <>
          <Container sx={{ width: '22%', mt: 4 }} className='sm-none'>
            <Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box
                className={`menu-item`}
                onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    navigate(`${user?.mypage_url}`);
                  }}
                >
                  TOP
                </Box>
                <Box 
                  className="menu-item"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    navigate(`/mypage-info/${user?.exhibitor_id}`);
                  }}
                >
                  出展者情報編集
                </Box>
                {/* <Box
                  className="menu-group"
                  id="hover-block"
                  onMouseEnter={() => {}}
                  onMouseLeave={() => {}}
                >
                  <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                    申請フォーム
                  </Box>
                    {showFormMenu && (
                      <Box className="hover-menu">
                        <Typography
                          sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                          className='form-button'
                          onClick={() => navigate('/form-require')}
                        >
                          必須フォーム<br />
                          (全出展者対象)
                        </Typography>
                        <Typography
                          sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                          className='form-button'
                          onClick={() => navigate('/form-optional')}
                        >
                          任意フォーム<br />
                          (該当出展者対象)
                        </Typography>
                      </Box>
                    )}
                </Box> */}
                <Box 
                  className="menu-item"
                  onClick={() => {
                    navigate('/mail-form/');
                  }}
                >
                  お問い合わせ
                </Box>
                {renderMenuItems()}
                <Box 
                  className="menu-item"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user') || '{}');
                    const mypage = user?.mypage_url;

                    handleScrollTo('news', mypage);
                  }}
                >
                  お知らせ
                </Box>
                <Box
                  className="menu-item"
                  onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
                >
                  個人情報保護方針
                </Box>
              </Box>
            </Box>
            <BackButton />
          </Container>
          <HamburgerMenu />
          </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed', width: '14%' }}>
              <Typography variant="h6" className="f-16">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2, maxWidth: '100%' }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Typography variant="h6">運送・会場内荷役作業申込</Typography>
        <FormGroup sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                  <Grid size={6}><TextField fullWidth label="氏名" name="user_3_name" value={formData.user_3_name} onChange={handleChange("user_3_name")} disabled={fieldsDisabled} error={!!submitErrors.user_3_name} helperText={submitErrors.user_3_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                  <Grid size={6}><TextField fullWidth label="部署" name="user_3_department" value={formData.user_3_department} onChange={handleChange("user_3_department")} disabled={fieldsDisabled} error={!!submitErrors.user_3_department} helperText={submitErrors.user_3_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                  <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_3_phone" value={formData.user_3_phone} onChange={handleChange("user_3_phone")} disabled={fieldsDisabled} error={!!submitErrors.user_3_phone} helperText={submitErrors.user_3_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                  <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_3_tel" value={formData.user_3_tel} onChange={handleChange("user_3_tel")} disabled={fieldsDisabled} error={!!submitErrors.user_3_tel} helperText={submitErrors.user_3_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                <Typography variant="h6" gutterBottom>
                請求先情報
                </Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsInvoice} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                {user?.co_exhibit && sameAsInvoice === "different" && (
                  <Button
                    variant="outlined"
                    onClick={handleParentInvoiceClick}
                    disabled={loading}
                    style={{ marginBottom: "16px" }}
                  >
                    親出展者に請求する
                  </Button>
                )}
                </FormControl>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={formData.invoice_company_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_company_name: e.target.value })} error={!!submitErrors.invoice_company_name} helperText={submitErrors.invoice_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={formData.invoice_user_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_user_name: e.target.value })} error={!!submitErrors.invoice_user_name} helperText={submitErrors.invoice_user_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先メールアドレス" value={formData.invoice_email} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_email: e.target.value })} error={!!submitErrors.invoice_email} helperText={submitErrors.invoice_email} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="郵便番号" value={formData.invoice_zip} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_zip: e.target.value })} error={!!submitErrors.invoice_zip} helperText={submitErrors.invoice_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先住所" value={formData.invoice_address} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_address: e.target.value })} error={!!submitErrors.invoice_address} helperText={submitErrors.invoice_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="電話番号" value={formData.invoice_tel} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_tel: e.target.value })} error={!!submitErrors.invoice_tel} helperText={submitErrors.invoice_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="FAX番号" value={formData.invoice_fax} onChange={(e) => setFormData({ ...formData, invoice_fax: e.target.value })} /></Grid>
                </Grid>

                <Grid size={12}>
                  <FormControl
                    fullWidth
                    error={!!submitErrors.select_plans}   // ← errorはここ！
                  >
                    <FormLabel>依頼内容</FormLabel>

                    <FormGroup>
                      {[
                        "会場内荷役作業を希望する",
                        "特別作業を希望する",
                        "重量出展物用の鉄板貸与を希望する",
                      ].map((option) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Checkbox
                              checked={selectedPlans.includes(option)}
                              onChange={handleSelectPlansChange(option)}
                              name="select_plans"
                            />
                          }
                          label={option}
                        />
                      ))}
                    </FormGroup>

                    {submitErrors.select_plans && (
                      <FormHelperText
                        sx={{ color: "#f10a0a", fontWeight: "bold" }}
                      >
                        {submitErrors.select_plans}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Typography variant="h6" gutterBottom>
                詳細の依頼内容
                </Typography>
                <Typography>該当の事項をご入力ください。</Typography>
                <Grid container spacing={2}>
                  <Grid size={6} sx={{ width: '100%' }}>
                      <FormLabel>搬入時</FormLabel>
                      <FormGroup row>
                        {["会場まで輸送", "トラックからの荷下ろし"].map(option => (
                          <FormControlLabel
                            key={option}
                            control={
                              <Checkbox
                                checked={
                                  formData.in_moving === "どちらも" ||
                                  formData.in_moving?.includes(option)
                                }
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setFormData(prev => {
                                    let updated;
                                    if (prev.in_moving === "どちらも") {
                                      // 既に「どちらも」の場合、両方選択状態なので一旦配列化
                                      updated = ["会場まで輸送", "トラックからの荷下ろし"];
                                    } else {
                                      updated = prev.in_moving || [];
                                    }

                                    if (checked) {
                                      updated = [...new Set([...updated, option])];
                                    } else {
                                      updated = updated.filter(o => o !== option);
                                    }

                                    // 両方チェックされたら「どちらも」に置き換え
                                    if (updated.includes("会場まで輸送") && updated.includes("トラックからの荷下ろし")) {
                                      updated = "どちらも";
                                    }

                                    return { ...prev, in_moving: updated };
                                  });
                                }}
                              />
                            }
                            label={option}
                          />
                        ))}
                      </FormGroup>

                      <FormLabel>搬出時</FormLabel>
                      <FormGroup row>
                        {["会場内トラックへの積込み", "会場から目的地まで輸送"].map(option => (
                          <FormControlLabel
                            key={option}
                            control={
                              <Checkbox
                                checked={
                                  formData.out_moving === "どちらも" ||
                                  formData.out_moving?.includes(option)
                                }
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setFormData(prev => {
                                    let updated;
                                    if (prev.out_moving === "どちらも") {
                                      updated = ["会場内トラックへの積込み", "会場から目的地まで輸送"];
                                    } else {
                                      updated = prev.out_moving || [];
                                    }

                                    if (checked) {
                                      updated = [...new Set([...updated, option])];
                                    } else {
                                      updated = updated.filter(o => o !== option);
                                    }

                                    if (updated.includes("会場内トラックへの積込み") && updated.includes("会場から目的地まで輸送")) {
                                      updated = "どちらも";
                                    }

                                    return { ...prev, out_moving: updated };
                                  });
                                }}
                              />
                            }
                            label={option}
                          />
                        ))}
                      </FormGroup>
                      <RadioGroup
                        row
                        value={formData.moving_select === null ? "" : String(formData.moving_select)}
                        onChange={(e) =>
                          setFormData({ ...formData, moving_select: e.target.value === "true" })
                        }
                      >
                        <FormControlLabel value="true" control={<Radio />} label="出展者自己扱" />
                        <FormControlLabel value="false" control={<Radio />} label="業者扱" />
                    </RadioGroup>
                  </Grid>
                  
                  {!formData.moving_select && (
                    <>
                    <Typography>輸送取扱業者</Typography>
                    <Grid container spacing={2}>
                      <Grid size={6}><TextField fullWidth label="輸送取扱業者名" value={formData.moving_name} onChange={(e) => setFormData({ ...formData, moving_name: e.target.value })} /></Grid>
                      <Grid size={12}><TextField fullWidth label="郵便番号" value={formData.zip} onChange={(e) => setFormData({ ...formData, zip: e.target.value })} /></Grid>
                      <Grid size={12}><TextField fullWidth label="住所" value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} /></Grid>
                      <Grid size={6}><TextField fullWidth label="担当者名" value={formData.user_name} onChange={(e) => setFormData({ ...formData, user_name: e.target.value })} /></Grid>
                      <Grid size={6}><TextField fullWidth label="携帯電話番号" value={formData.phone_number} onChange={(e) => setFormData({ ...formData, phone_number: e.target.value })} /></Grid>
                      <Grid size={6}><TextField fullWidth label="出荷場所" value={formData.place} onChange={(e) => setFormData({ ...formData, place: e.target.value })} /></Grid>
                    </Grid>
                    </>
                  )}
                    <Box sx={{width: '100%'}}>
                      <Typography>輸送物詳細</Typography>
                      <Grid container spacing={2}>
                        <Grid size={12}><TextField fullWidth label="品名" value={formData.goods_name} onChange={(e) => setFormData({ ...formData, goods_name: e.target.value })} /></Grid>
                        <Grid size={4}><TextField fullWidth label="個数" value={formData.goods_number} onChange={handleChange("goods_number",intValidator({ label: "個数" }))} error={!!errors.goods_number} helperText={errors.goods_number}/></Grid>
                        <Grid size={4}><TextField fullWidth label="荷姿" value={formData.style} onChange={(e) => setFormData({ ...formData, style: e.target.value })} /></Grid>
                        <Grid size={4}><TextField fullWidth label="重量(kg)" value={formData.weight} onChange={handleChange("weight",decimalValidator({ scale: 2, label: "重量" }))} error={!!errors.weight} helperText={errors.weight} /></Grid>
                        <Grid size={4}><TextField fullWidth label="最大重量(kg)" value={formData.max_weight} onChange={handleChange("max_weight",decimalValidator({ scale: 2, label: "最大重量" }))} error={!!errors.max_weight} helperText={errors.max_weight} /></Grid>
                        <Grid size={4}><TextField fullWidth label="容積(㎥)" value={formData.quantity} onChange={handleChange("quantity",decimalValidator({ scale: 2, label: "容積" }))} error={!!errors.quantity} helperText={errors.quantity} /></Grid>
                        <Grid size={4}><TextField fullWidth label="最大長さ(ｍ)" value={formData.max_length} onChange={handleChange("max_length",decimalValidator({ scale: 2, label: "最大長さ" }))} error={!!errors.max_length} helperText={errors.max_length} /></Grid>
                        <Grid size={4}><TextField fullWidth label="最大幅(ｍ)" value={formData.max_width} onChange={handleChange("max_width",decimalValidator({ scale: 2, label: "最大幅" }))} error={!!errors.max_width} helperText={errors.max_width} /></Grid>
                        <Grid size={4}><TextField fullWidth label="最大高さ(ｍ)" value={formData.max_height} onChange={handleChange("max_height",decimalValidator({ scale: 2, label: "最大高さ" }))} error={!!errors.max_height} helperText={errors.max_height} /></Grid>
                        <Grid size={4}>
                        <TextField
                          fullWidth
                          label="最大容量"
                          value={
                            (formData.max_length || 0) *
                            (formData.max_width || 0) *
                            (formData.max_height || 0)
                          }
                          InputProps={{ readOnly: true }} // 手入力は不可
                        />
                        </Grid>
                      </Grid>
                    </Box>
                </Grid>

                <Grid container spacing={2}>
                  <Grid size={6}><TextField fullWidth label="搬入日" type="datetime-local" InputLabelProps={{ shrink: true }} value={formData.in_date} onChange={(e) => setFormData({ ...formData, in_date: e.target.value })} /></Grid>
                  <Grid size={6}><TextField fullWidth label="搬出日" type="datetime-local" InputLabelProps={{ shrink: true }} value={formData.out_date} onChange={(e) => setFormData({ ...formData, out_date: e.target.value })} /></Grid>
                </Grid>

                <Typography variant="h6">車両台数：荷役機器について</Typography>
                <Typography color="error">荷役依頼する車両台数等を必要に応じてご入力ください。</Typography>

                <Grid container spacing={2}>
                <Grid size={4}><TextField fullWidth label="中型車台数（4t以下）" value={formData.norm_num} onChange={handleChange("norm_num",intValidator({ label: "中型車台数" }))} error={!!errors.norm_num} helperText={errors.norm_num} inputMode="numeric" /></Grid>
                <Grid size={4}><TextField fullWidth label="大型車台数（5t以上）" value={formData.big_num} onChange={handleChange("big_num",intValidator({ label: "大型車台数" }))} error={!!errors.big_num} helperText={errors.big_num} inputMode="numeric" /></Grid>
                <Grid size={4}><TextField fullWidth label="トレーラー台数" value={formData.trail_num} onChange={handleChange("trail_num",intValidator({ label: "トレーラー台数" }))} error={!!errors.trail_num} helperText={errors.trail_num} inputMode="numeric" /></Grid>
                </Grid>

                <TextField fullWidth label="搬入機器（フォークリフト等）" value={formData.moving_device} onChange={(e) => setFormData({ ...formData, moving_device: e.target.value })} />
                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※運送・会場内荷役作業申込について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={4} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            )}
        </FormGroup>
        <div style={{padding: '15px'}}></div>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            日本通運(株)　名古屋支店<br />
            担当：野底<br />
            TEL:0568-42-2260<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
        </Container>
      </Container>
      
      {!isCorpModal && (
        <>
        <Container sx={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit(exhibitorId)}
          >
            提出する
          </Button>
        </Container>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
       )}
       {!!changeModalOpen &&(
        <Box display="flex" justifyContent="center" gap={2} mt={2}>
          <Button
            variant="contained"
            onClick={handleCorrection}
            sx={{
              backgroundColor: "red",
              color: "white",
              "&:hover": {
                backgroundColor: "darkred",
              },
            }}
          >
            再提出
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleConfirm}
          >
            完了
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => setFormModalOpen(false)}
          >
            中断
          </Button>
        </Box>
       )}
    </div>
  );
};

export default Comp3Sub;